import Vue from 'vue';
// @ts-ignore
import Tungsten from '@stafftastic/tungsten/src/main';

Vue.use(Tungsten, {
  validation: {
    rules: ['required', 'email'],
  },
});
